export { default } from './DialogActions';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/DialogActions/index.js
// module id = 228
// module chunks = 121